import { AiFillTikTok } from "react-icons/ai";
import {
  FaFacebook,
  FaInstagram,
  FaRegCopyright,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import logo from "../../src/images/logo.png";
import { Link } from "react-router-dom";
import map from "../images/nuhaMap.jpg";

const FooterSection = () => {
  return (
    // <div className="bg-[#265fc9]">
    //   <div className="mx-6 pt-3 p-1 md:pt-2 md:mx-10 md:p-4">
    //     <div className="grid grid-cols-1 gap-x-4 gap-y-2 md:flex md:justify-between md:gap-x-6 md:gap-y-6">
    //       <div className="text-white flex-1" lang="bn">
    //         <div className="flex py-1">
    //           <Link to="/" className="flex ">
    //             <img
    //               src={logo}
    //               alt="Noyabibi Logo"
    //               className="md:h-12 h-12 w-auto"
    //             />
    //           </Link>
    //         </div>
    //         <p className="md:mb-2 mb-1 md:text-base text-xs">
    // ১১,১২,১৩, দ্বিতীয় তলা, বনলতা মার্কেট, কাঁচা বাজার, ঢাকা
    // নিউমার্কেট, ঢাকা ১২০৫
    //         </p>
    //         <a
    //           href="https://www.google.com/maps/search/?api=1&query=Nuha+baby+collection,+Shop+no.+11,12,13,+1st+Floor,+Banalota+Kacha+Bazar+Market,+New+Market+-+Pilkhana+Rd,+Dhaka+1205"
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           className="flex items-center"
    //         >
    //           <img
    //             src={map}
    //             alt="Noyabibi Logo"
    //             className="md:h-12 h-8 w-auto mb-2"
    //           />
    //         </a>

    //         <p className="md:mb-2 mb-1 md:text-base text-xs text-white ">
    //           ফোন: 01971787661
    //         </p>
    //         <p className="md:mb-2 mb-1 md:text-base text-xs text-white ">
    //           হেল্পলাইন: 01971787661
    //         </p>
    //         <p className="md:mb-2 mb-1 md:text-base text-xs text-white ">
    //           ইমেইল: nohababycollection@gmail.com
    //         </p>
    //       </div>

    //       <div className="grid grid-cols-2 gap-4 md:flex md:flex-1 md:gap-6">
    //         <div className="text-white md:py-5 py-2 flex-1">
    //           <h3
    //             lang="bn"
    //             className="mb-3 font-semibold lg:text-xl md:text-lg text-sm"
    //           >
    //             আমাদের সম্পর্কে
    //           </h3>
    //           <p className="mb-2 md:text-base text-xs text-white ">About Us</p>
    //           <p className="mb-2 md:text-base text-xs text-white ">
    //             Contact Us
    //           </p>
    //           <p className="mb-2 md:text-base text-xs text-white ">
    //             Return Policy
    //           </p>
    //           <p className="mb-2 md:text-base text-xs text-white ">
    //             Refund Policy
    //           </p>
    //           <p className="mb-2 md:text-base text-xs text-white ">
    //             Cancellation Policy
    //           </p>
    //         </div>

    //         {/* Column 3 */}
    //         <div className=" md:py-5 py-2 flex-1">
    //           <h3
    //             lang="bn"
    //             className="text-white  mb-3 font-semibold lg:text-xl md:text-lg text-sm"
    //           >
    //             সামাজিক যোগাযোগ মাধ্যম
    //           </h3>
    //           <div className="text-white flex gap-4">
    //             <a
    //               href="https://www.facebook.com/share/1C6r6y8inF/"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               <FaFacebook className="hover:text-blue-600 text-xl cursor-pointer" />
    //             </a>

    //             <a
    //               href="https://www.tiktok.com/@nbcmartltd?_r=1&_t=ZS-937fxZyi2Jp"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               <AiFillTikTok className="hover:text-cyan-300 text-xl cursor-pointer" />
    //             </a>

    //             <a
    //               href={`https://wa.me/8801971787661`}
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               <FaWhatsapp className="hover:text-green-600 text-xl cursor-pointer" />
    //             </a>
    //             <a
    //               href="https://www.youtube.com/@nbc380?si=6OscuvYY3wqmoqWL"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               <FaYoutube className="hover:text-red-600 text-xl cursor-pointer" />
    //             </a>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-300 border-t border-dashed border-gray-600 pt-2">
    //       <div className="flex items-center gap-1">
    //         <FaRegCopyright className="text-gray-400" />
    //         <span>Nuha Baby Collection</span>
    //       </div>

    // <div className="flex items-center gap-1">
    //   <span>Developed by</span>
    //   <a
    //     href="https://motionbooster.com"
    //     target="_blank"
    //     rel="noopener noreferrer"
    //     className="text-primary hover:underline hover:text-primary/80 transition"
    //   >
    //     Motion Booster
    //   </a>
    // </div>
    //     </div>
    //   </div>
    // </div>
    <footer className="mt-12 border-t border-slate-200 bg-white text-slate-700">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-8 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
        <section>
          <div className="flex py-1">
            <Link to="/" className="flex ">
              <img
                src={logo}
                alt="Noyabibi Logo"
                className="md:h-12 h-12 w-auto"
              />
            </Link>
          </div>
          <p className="mt-2 text-sm text-slate-600">
            ১১,১২,১৩, দ্বিতীয় তলা, বনলতা মার্কেট, কাঁচা বাজার, ঢাকা নিউমার্কেট,
            ঢাকা ১২০৫
          </p>
        </section>

        <section>
          <h4 className="text-sm font-bold uppercase tracking-wide text-slate-900">
            Support
          </h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a href="#/terms" className="transition hover:text-slate-900">
                ফোন: 01971787661
              </a>
            </li>
            <li>
              <span>হেল্পলাইন: 01971787661</span>
            </li>
            <li>
              <span>ইমেইল: nohababycollection@gmail.com</span>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-sm font-bold uppercase tracking-wide text-slate-900">
            Quick Links
          </h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a href="#/dashboard" className="transition hover:text-slate-900">
                Home
              </a>
            </li>
            {/* <li>
              <a href="#/products" className="transition hover:text-slate-900">
                Products
              </a>
            </li> */}
            <li>
              <a href="#/about" className="transition hover:text-slate-900">
                About Us
              </a>
            </li>
            <li>
              <a href="#/contact" className="transition hover:text-slate-900">
                Contact
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-sm font-bold uppercase tracking-wide text-slate-900">
            Stay Connected
          </h4>
          <p className="mt-3 text-sm text-slate-600">
            Get updates on offers and new arrivals.
          </p>
          <div className="mt-4 flex items-center gap-2">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 transition hover:bg-slate-200"
            >
              <FaFacebook />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 transition hover:bg-slate-200"
            >
              <AiFillTikTok />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 transition hover:bg-slate-200"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 transition hover:bg-slate-200"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 transition hover:bg-slate-200"
            >
              <FaYoutube />
            </a>
          </div>
        </section>
      </div>

      <div className="border-t border-slate-200">
        <div className="flex justify-between mx-auto w-full max-w-7xl px-4 py-4 text-center text-xs text-slate-500 sm:px-6 sm:text-sm">
          <div className="flex items-center gap-1">
            <FaRegCopyright className="text-gray-400" />
            <span>Baby Shop</span>
          </div>
                    <div className="flex items-center gap-1">
            <span>Developed by</span>
            <a
              href="https://motionbooster.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline hover:text-primary/80 transition"
            >
              Motion Booster
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
